import type { FC } from 'react';

import { Skeleton } from '@mint-lib/tw-components';

const TableGridSkeleton: FC = () => {
  const skeletonRows = Array.from({ length: 1 }, (_, index) => (
    <div
      key={index}
      className="flex h-8 border-b border-border-secondary px-4"
      data-testid="grid-skeleton"
    >
      <div className="flex flex-[3] items-center border-r border-border-secondary pl-5">
        <Skeleton className="h-4 w-3/4" />
      </div>

      {Array.from({ length: 4 }, (_, colIndex) => (
        <div
          key={colIndex}
          className="flex flex-1 items-center border-r border-border-secondary px-4"
        >
          <Skeleton className="h-4 w-2/3" />
        </div>
      ))}
    </div>
  ));

  return (
    <div className="flex-1 rounded-lg border border-border-secondary bg-ui-primary">
      <div className="flex h-11 rounded-t-lg border-b border-border-secondary bg-ui-primary px-4">
        <div className="flex flex-[3] items-center border-r border-border-secondary pl-5">
          <Skeleton className="h-4 w-16" />
        </div>

        {Array.from({ length: 4 }, (_, index) => (
          <div
            key={index}
            className="flex flex-1 items-center border-r border-border-secondary px-4"
          >
            <Skeleton className="h-4 w-12" />
          </div>
        ))}
      </div>

      <div className="min-h-[400px] bg-ui-primary">{skeletonRows}</div>
    </div>
  );
};

export default TableGridSkeleton;
